import request from '@/utils/request'

export const getServiceProviders = () =>
  request({
    url: '/service_providers/get-list',
    method: 'get'
  })

export const getServices = (serviceProviderId: number) =>
  request({
    url: '/service_providers/get-services-list?service_provider_id=' + serviceProviderId,
    method: 'get'
  })

export const saveServiceDiscount = (data: any) =>
  request({
    url: '/vouchers/create-discount',
    method: 'post',
    data
  })

export const getServiceDiscounts = (filter: any) =>
  request({
    url: '/vouchers/view-voucher/discount?filter=' + filter,
    method: 'get'
  })

export const updateServiceDiscounts = (data: any, voucherId: number) =>
  request({
    url: '/vouchers/update/' + voucherId,
    method: 'post',
    data
  })

  export const saveCoupons = (data: any) =>
  request({
    url: '/vouchers/create-coupon',
    method: 'post',
    data
  })

  export const getCoupons = (filter: any) =>
  request({
    url: '/vouchers/view-voucher/coupon?filter=' + filter,
    method: 'get'
  })

  export const getCouponUsers = (notificationSent: any, couponId: number) =>
  request({
    url: '/vouchers/get-users-by-coupon/' + couponId + '?notification_sent=' + notificationSent,
    method: 'get'
  })

  export const getCouponByUserType = (userType: any) =>
  request({
    url: '/vouchers/get-couponlist-by-usertype/' + userType,
    method: 'get'
  })

  export const getUserTypes = () =>
  request({
    url: '/vouchers/get-coupon-usertypes',
    method: 'get'
  })

  export const mapCoupons = (data: any) =>
  request({
    url: '/vouchers/map-coupons',
    method: 'post',
    data
  })
